import { REMOVE_TRUTHY_CART_VALUES } from "../../redux/actions/action.types";

export default function removeTruthyCartValues(valobj: any, stateHandler: any) {
  stateHandler({
    type: REMOVE_TRUTHY_CART_VALUES,
    payload: valobj,
  });
}
